import React from "react";
import { Paragraph } from "./Paragraph";
import CheckBoxTable from "./CheckBoxTable";

export interface QuestionAnswerProps {
  vraag: string | null;
  antwoord: string | null;
  mogelijkeAntwoorden?: string[] | null;
  toelichting?: string | null;
  index: number;
  namePrefix: string;
}

const QuestionAnswerBlock: React.FC<QuestionAnswerProps> = ({
  vraag,
  antwoord,
  mogelijkeAntwoorden,
  toelichting,
  index,
  namePrefix,
}) => {
  if (!antwoord || !vraag) return null;

  const hasMultipleAnswers =
    mogelijkeAntwoorden && mogelijkeAntwoorden.length > 1;

  if (hasMultipleAnswers) {
    return (
      <div className="break-avoid">
        <Paragraph noMarginBottom>
          <b>{vraag}</b>
        </Paragraph>
        <CheckBoxTable
          name={`${namePrefix}-${index}`}
          data={Object.fromEntries(
            mogelijkeAntwoorden.map((antw) => [antw, antw === antwoord])
          )}
        />
        {toelichting && (
          <Paragraph>
            <i>Toelichting:</i>
            <br />
            {toelichting}
          </Paragraph>
        )}
      </div>
    );
  }

  return (
    <Paragraph>
      <b>{vraag}</b>
      <br />
      {antwoord}
      <br />
      {toelichting && (
        <>
          <i>Toelichting:</i>
          <br />
          {toelichting}
        </>
      )}
    </Paragraph>
  );
};

export default QuestionAnswerBlock;
